module.exports = __webpack_public_path__ + "static/media/mermelada-flotante.7098fc6c.png";